import { render, staticRenderFns } from "./CourseUser.vue?vue&type=template&id=617bf1a5&scoped=true&"
import script from "./CourseUser.vue?vue&type=script&lang=js&"
export * from "./CourseUser.vue?vue&type=script&lang=js&"
import style0 from "./CourseUser.vue?vue&type=style&index=0&id=617bf1a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bf1a5",
  null
  
)

export default component.exports